module.exports = __webpack_public_path__ + "static/rainbowsafarihamper2-496c2f9cdd6b692956859c28c915b25c.jpeg";